<div id="principal-container">
    <div class="py-0 px-0 top-bg primary-400">
        <div class="p-12 complaint-header-data">
            <div fxLayout="column">
                <span class="m-8 p-4"> {{ 'COMPLAINTS.FIELDS.CODE' | translate }}: <strong> {{data.complaint.complaintCode}}</strong></span>
                
                <span class="m-8 p-4"> {{ 'COMPLAINTS.FIELDS.CREATEDDATE' | translate }}: <strong> {{data.complaint.createdDate | date:'yyyy-MM-dd'}}</strong></span>
            </div>
    
            <div fxLayout="column">
                <span class="m-8 p-4"> {{ 'COMPLAINTS.FIELDS.TYPE' | translate }}: <strong> {{data.complaint.formSubTypeDescription}}</strong></span>
    
                <span class="m-8 p-4"> {{ 'COMPLAINTS.FIELDS.COMPLAINTCLASSIFICATIONDESCRIPTION' | translate }}: <strong> {{data.complaint.complaintClassificationDescription}}</strong></span>
            </div>
        </div>
    </div>
    <mat-divider></mat-divider>
    <div class="mb-64">
        <app-form-component [readonly]="true"
            [formData]="data.complaint.complaintCompletedForm"></app-form-component>
    </div>

    <mat-divider></mat-divider>

    <mat-card class="close-modal-container">
        <div align="end">
            <button mat-raised-button class="mat-accent" (click)="dialogRef.close(true)">{{'DIALOGS.ACTIONS.ACCEPT' | translate}}</button>
        </div>
    </mat-card>
</div>